import React from 'react'


import { Box, Grid, Typography, Avatar, Button, Link } from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';
// import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import QuestionAnswerIcon from '@mui/icons-material/QuestionAnswer';

const CustomClientPortalProfile = ({companyName="SavoryBites",companyWebsite="https://Savorybites.com",ManagerName='Atif khan',MobileNumber="4785214565",handleResetClick=()=>{},handleMessageClick=()=>{}}) => {
  return (
    <Box
    sx={{
      width: "100%",
      p: 2,
      my:2,
      borderRadius: 2,
      boxShadow: "0px 3px 6px rgba(0,0,0,0.1)",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      backgroundColor: "#ffffff",
    }}
  >
    <Grid container spacing={2} alignItems="center">
      {/* Avatar and Name Section */}
      <Grid item sm={3} sx={{ display: "flex", alignItems: "center" }}>
        <Avatar
          sx={{ width: 90, height: 90, backgroundColor: "#000000", mx: 2 }}
        >
          <Typography variant="h6" color="white">
           
           {companyName?.charAt(0).toUpperCase()} / {companyName?.split(" ")[1]?.charAt(0).toUpperCase() || companyName.charAt(companyName.length-1)  }
          </Typography>
        </Avatar>
        <Box>
          <Typography variant="h6" fontWeight={600}>
          {companyName}
          </Typography>
          <Link
            href="https://Savorybites.com"
            target="_blank"
            underline="hover"
            sx={{ color: "#007BFF", fontSize: 14 }}
          >
          {companyWebsite}
          </Link>
        </Box>
      </Grid>

      <Grid item sm={3}>
        <Typography variant="body2" color="#9A9A9A"sx={{fontWeight:"500",fontSize:"14px"}}>
          Manager
        </Typography>
        <Typography variant="body2" color="#313131"sx={{fontWeight:"500",fontSize:"14px"}}>
         {ManagerName}
        </Typography>
      </Grid>

      <Grid item sm={3}>
        <Typography variant="body2" color="#9A9A9A" sx={{fontWeight:"500",fontSize:"14px"}}>
          Mobile Number
        </Typography>
        <Typography variant="body2" color="#313131"sx={{fontWeight:"500",fontSize:"14px"}}>
          {MobileNumber}
        </Typography>
      </Grid>

      {/* Reset and Message Buttons */}
      <Grid
        item
        sm={3}
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-end",
          justifyContent: "end",
        }}
      >
        <Button
          startIcon={<RefreshIcon />}
          onClick={handleResetClick}
          sx={{
            textTransform: "none",
            color: "#000",
            ":hover": { backgroundColor: "#e0e0e0" },
            borderRadius: 2,
            minWidth: 32,
            
          }}
        >
          Reset Credential
        </Button>
        <Button
          variant="outlined"
          onClick={handleMessageClick}
          startIcon={<QuestionAnswerIcon />}
          sx={{
            textTransform: "none",
            color: "#000",
            borderRadius: 2,
            marginTop: 1,
            borderColor:"gray"
          }}
        >
          Message
        </Button>
      </Grid>
    </Grid>
  </Box>
  )
}

export default CustomClientPortalProfile